import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useEffect, useState, useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import { useAdsEvents } from '@magalu/mixer-graphql';
import { usePublisher } from '@magalu/mixer-publisher';
import { useAdsProvider } from '../../../../contexts';
import { getCustomerId, trackClick, trackImpression } from '../AdsBanner.utils';
export var useAdsBanner = function useAdsBanner(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var adsPath = staticProps.adsPath,
    campaignId = staticProps.campaignId,
    staticCustomerId = staticProps.customerId,
    imageUrl = staticProps.imageUrl,
    index = staticProps.index,
    _staticProps$isBanner = staticProps.isBannerCarousel,
    isBannerCarousel = _staticProps$isBanner === void 0 ? false : _staticProps$isBanner,
    position = staticProps.position,
    redirectUrl = staticProps.redirectUrl,
    screenName = staticProps.screenName,
    size = staticProps.size,
    slot = staticProps.slot,
    trackId = staticProps.trackId;
  var customerId = getCustomerId(staticCustomerId);
  var _useAdsProvider = useAdsProvider(),
    ads = _useAdsProvider.ads,
    getBannerBySlot = _useAdsProvider.getBannerBySlot,
    isBannerLoading = _useAdsProvider.isLoading;
  var _useState = useState(imageUrl ? {
      campaignId: campaignId,
      imageUrl: imageUrl,
      redirectUrl: redirectUrl,
      trackId: trackId
    } : null),
    _useState2 = _slicedToArray(_useState, 2),
    banner = _useState2[0],
    setBanner = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasViewed = _useState4[0],
    setHasViewed = _useState4[1];
  var inViewConfig = useMemo(function () {
    return {
      threshold: 0.5,
      triggerOnce: false
    };
  }, []);
  var _useInView = useInView(inViewConfig),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var adsEventsData = useMemo(function () {
    return {
      adsPath: adsPath,
      customerId: customerId,
      data: data,
      structure: structure
    };
  }, [adsPath, customerId, data, structure]);
  var _useAdsEvents = useAdsEvents(adsEventsData),
    sendAdsClickEvents = _useAdsEvents.sendAdsClickEvents,
    sendAdsImpressionEvents = _useAdsEvents.sendAdsImpressionEvents;
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var isVideo = useMemo(function () {
    var _banner$imageUrl$incl, _banner$imageUrl;
    return (_banner$imageUrl$incl = banner == null ? void 0 : (_banner$imageUrl = banner.imageUrl) == null ? void 0 : _banner$imageUrl.includes('.m3u8')) !== null && _banner$imageUrl$incl !== void 0 ? _banner$imageUrl$incl : false;
  }, [banner]);
  var handleClick = useCallback(function () {
    trackClick({
      banner: banner,
      eventDetails: {
        index: index,
        position: position,
        size: size,
        slot: slot
      },
      isBannerCarousel: isBannerCarousel,
      isVideo: isVideo,
      screenName: screenName,
      structure: structure,
      trackingFunctions: {
        publish: publish,
        sendServerClickEvents: sendAdsClickEvents
      }
    });
  }, [banner, index, isBannerCarousel, isVideo, position, publish, screenName, sendAdsClickEvents, size, slot, structure]);
  useEffect(function () {
    if (isBannerCarousel || !getBannerBySlot || !ads) {
      return;
    }
    var bannersInSlot = getBannerBySlot(slot);
    var newBanner = bannersInSlot == null ? void 0 : bannersInSlot[0];
    setBanner(function (currentBanner) {
      if (newBanner && newBanner.trackId !== (currentBanner == null ? void 0 : currentBanner.trackId)) {
        return newBanner;
      }
      return currentBanner;
    });
  }, [ads, getBannerBySlot, isBannerCarousel, slot]);
  useEffect(function () {
    if (!inView || !banner || hasViewed) {
      return;
    }
    setHasViewed(true);
    trackImpression({
      banner: banner,
      eventDetails: {
        index: index,
        position: position,
        size: size,
        slot: slot
      },
      isBannerCarousel: isBannerCarousel,
      isVideo: isVideo,
      publish: publish,
      screenName: screenName,
      sendServerImpressionEvents: sendAdsImpressionEvents,
      structure: structure
    });
  }, [banner, hasViewed, index, inView, isBannerCarousel, isVideo, position, publish, screenName, sendAdsImpressionEvents, size, slot, structure]);
  return {
    banner: banner,
    handleClick: handleClick,
    inView: inView,
    isBannerLoading: isBannerLoading,
    isVideo: isVideo,
    ref: ref
  };
};